export const GET_USER_LIST = "GET_USER_LIST"
export const GET_USER_LIST_SUCCESS = "GET_USER_LIST_SUCCESS"
export const USER_API_ERROR = "USER_API_ERROR"